import { useEffect, useState } from "react";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { Db } from "./../../firebase";
import { Link } from "react-router-dom";

const EventsArchive = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const q = query(collection(Db, "event_photos"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setEvents(data);
      } catch (error) {
        console.error("🔥 Σφάλμα φόρτωσης αρχείου events:", error);
      }
    };

    fetchEvents();
  }, []);

  return (
    <section className="py-5" style={{ backgroundColor: "#0b0b0b" }}>
      <div className="container text-light">
        <h2 className="fw-bold text-center mb-5 text-uppercase">From The Pit Archive</h2>

        <div className="row g-4">
          {events.map((event) => {
            const firstPhoto = event.images?.[0];
            return (
              <div className="col-md-4" key={event.id}>
                <Link
                  to={`/events/${event.id}`}
                  className="text-decoration-none text-light"
                >
                  <div className="card bg-dark border-0 shadow-sm">
                    {firstPhoto ? (
                      <img
                        src={firstPhoto}
                        alt={event.title}
                        className="card-img-top"
                        style={{
                          height: "250px",
                          objectFit: "cover",
                          filter: "brightness(75%)",
                        }}
                      />
                    ) : (
                      <div
                        className="bg-secondary"
                        style={{
                          height: "250px",
                        }}
                      ></div>
                    )}
                    <div className="card-body">
                      <h5 className="card-title text-uppercase fw-bold">
                        {event.title || "Untitled Event"}
                      </h5>
                      <p className="card-text text-secondary">
                        {event.date || "Χωρίς ημερομηνία"}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default EventsArchive;
